import { appSettings } from '@/shared/consts/appSettings'
import { Contentwrapper } from '@/components/ContentWrapper'
import { useIsActiveBreakPoint } from '@/hooks/useIsActiveBreakPoint'
import { useChat } from '@/hooks/useChat'
import { sendEvent } from '@/services/mixPanelService'
import { Fallback } from '@/app/fallback/components'
import { CuraButtonOutline, CuraParagraph } from '@rededor/cura-react'
import { Show } from '../Show'
import { storageKeys } from '@/shared/consts/storageKeys'

export const ErrorPageContent = () => {
  const { open: openChat } = useChat()
  const isMobile = useIsActiveBreakPoint('medium')

  const isSecondError =
    sessionStorage.getItem(storageKeys.genericErrorShown) === 'true'

  const handleRestart = () => {
    sendEvent({
      eventName: 'CTA',
      data: {
        LABEL: 'INICIE NOVAMENTE',
        TYPE: 'button',
        DESCRIPTION: 'Clicou no botão de iniciar novamente',
        ACTION: `Enviar para a tela de especialidade / profissional`
      }
    })

    window.location.href = appSettings.publicUrl
  }

  return (
    <Contentwrapper>
      <Fallback.Root>
        <Fallback.Title>
          <span style={isMobile ? { lineHeight: '1.5' } : undefined}>
            Infelizmente, algo inesperado ocorreu e não conseguimos realizar
            este seu agendamento. Por favor, tente novamente.
          </span>
        </Fallback.Title>

        <Show when={isSecondError}>
          <Fallback.ButtonsContinue openChat={openChat} withWhatsapp />

          <CuraParagraph marginBlock="24px" color="neutral-dark">
            Ou se preferir:
          </CuraParagraph>
        </Show>

        <CuraButtonOutline
          color="primary"
          size="medium"
          href={appSettings.publicUrl}
          textAlign="center"
          style={{
            width: isMobile ? '100%' : '285px',
            marginTop: !isSecondError ? '24px' : 'initial'
          }}
          onClick={handleRestart}
        >
          INICIE NOVAMENTE
        </CuraButtonOutline>
      </Fallback.Root>
    </Contentwrapper>
  )
}
